import { Flex, Pagination as MantinePagination, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

export interface PaginationProps {
  currentPage: number;
  onChange: (value: number) => void;
  totalPages: number | null;
  pageSize: number;
  totalElements: number | undefined;
}

export const Pagination = ({ totalPages, currentPage, onChange, totalElements, pageSize }: PaginationProps) => {
  const { t } = useTranslation();

  if (totalPages == null || totalPages === 1) {
    return null;
  }

  return (
    <Flex
      direction="column"
      justify="center"
      align="center"
      mt="20px"
    >
      <MantinePagination
        total={totalPages}
        withEdges
        onChange={newPage => onChange(newPage - 1)}
        value={currentPage + 1}
      />
      {totalElements && pageSize && (
        <Text
          mt="10px"
          variant="meta"
        >
          {t('pagination.ofTotal', { pageSize, totalElements })}
        </Text>
      )}
    </Flex>
  );
};
